import { EUtmParameters, type TUtmParameters } from '@/utils/utm/types'

const getUtmParameter = (queryParameters: URLSearchParams, key: string) => queryParameters.get(key) ?? undefined

export const getUtmParametersFromSearchString = (searchString: string): TUtmParameters => {
  const queries = new URLSearchParams(searchString)

  const utmCampaign = getUtmParameter(queries, EUtmParameters.UTM_CAMPAIGN)
  const utmMedium = getUtmParameter(queries, EUtmParameters.UTM_MEDIUM)
  const utmSource = getUtmParameter(queries, EUtmParameters.UTM_SOURCE)
  const utmContent = getUtmParameter(queries, EUtmParameters.UTM_CONTENT)
  const utmTerm = getUtmParameter(queries, EUtmParameters.UTM_TERM)

  return {
    utmCampaign,
    utmMedium,
    utmSource,
    utmContent,
    utmTerm,
  }
}
